import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../http";
import { useForBindingId } from '../../../forBinding';
import { AreaDTO } from '../../types';
import { getApiErrorMessage, toApiError } from "../utils";
import { createFormData } from "../helpers/createFormdata";

interface RequestPostAreaParams {
    propId: string,
    data: Omit<AreaDTO, 'avatar'> & { avatar?: File | null }
}

export function usePostArea() {
    const queryClient = useQueryClient();
    const forBinding = useForBindingId();
    const mutate = useMutation({
        mutationFn: async ({ propId, data }: RequestPostAreaParams) => {
            try {
                const form = createFormData(data);
                return (await api.post<AreaDTO>(`/user/prop/${propId}/area/create`, form, {
                    params: { forBinding },
                })).data;
            } catch (error) {
                throw toApiError(error, 'Erro ao criar área');
            }
        },
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({ queryKey: ['areas'] });
            queryClient.invalidateQueries({ queryKey: ['propertyId', variables.propId] });
        },
        onError: (error) => console.error('Erro ao criar área:', getApiErrorMessage(error, 'Erro ao criar área'))
    })

    return mutate
}
